export default {
    WARPED_TO: 'Du hast dich nach {{name}} teleportiert.',

    CANNOT_WARP_ACHIEVEMENT:
        'Dieser Teleport erfordert eine Errungenschaft, die vor der Benutzung abgeschlossen werden muss.',
    CANNOT_WARP_QUEST:
        'Du musst {{questName}} abschließen, um nach {{name}} zu teleportieren zu können.',
    CANNOT_WARP_LEVEL:
        'Du musst mindestens Level {{level}} sein, um hierher zu teleportieren zu können.',
    CANNOT_WARP_JAIL: 'Du kannst nicht teleportieren, du bist für weitere {{time}} eingesperrt.',
    CANNOT_WARP_TUTORIAL: 'Du musst das Tutorial beenden, bevor du teleportieren kannst.',
    CANNOT_WARP_COMBAT:
        'Du musst 10 Sekunden nach Beendigung des Kampfes warten, um zu teleportieren zu können.',
    CANNOT_WARP_COOLDOWN: 'Du musst weitere {{time}} warten, um zu teleportieren zu können.'
} as const;
